// extracted by mini-css-extract-plugin
export default {"container":"IconHeader-module--container--27452","icon":"IconHeader-module--icon--40fa7"};